import React from 'react';
import { TSize } from '../../../types/types';

interface ISpacingCustomProps {
    children?: React.ReactNode;
    marginLeft?: number;
    marginRight?: number;
    marginTop?: number;
    marginBottom?: number;
    paddingLeft?: number;
    paddingRight?: number;
    paddingTop?: number;
    paddingBottom?: number;
    stretch?: boolean;
}

export const SpacingCustom: React.FC<ISpacingCustomProps> = ({
    children,
    marginLeft = 0,
    marginRight = 0,
    marginBottom = 0,
    marginTop = 0,
    paddingBottom = 0,
    paddingLeft = 0,
    paddingRight = 0,
    paddingTop = 0,
    stretch = false,
}) => {
    return (
        <div
            style={{
                height: `${stretch && 'calc(100% - 48px)'}`,
                marginLeft: `${marginLeft}rem`,
                marginRight: `${marginRight}rem`,
                marginBottom: `${marginBottom}rem`,
                marginTop: `${marginTop}rem`,
                paddingBottom: `${paddingBottom}rem`,
                paddingLeft: `${paddingLeft}rem`,
                paddingRight: `${paddingRight}rem`,
                paddingTop: `${paddingTop}rem`,
            }}
        >
            {children}
        </div>
    );
};
